export const selectSelectedView = state => state.cameraPageState?.selectedView;
